import React from "react";
import { useTranslation } from "react-i18next";

const Loading = ({ cssClass = "w-full text-center" }) => {
    const { t } = useTranslation();
    return <div className={cssClass}>{t("Loading")}...</div>;
};

export default Loading;
